// @core/api/endpoints/subscription/get_bundle_subscription.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BundleSubscriptionResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Get bundle subscription details
 * Retrieves details of a tenant's bundle subscription including status, pricing, and linked product subscriptions.
 */
export async function GetBundleSubscription(
  subscription_id: string,
  options?: RequestOptions
): Promise<BundleSubscriptionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/bundle-subscriptions/:subscription_id`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  const requestOptions = options;
  return client.get<BundleSubscriptionResponse>(requestPath, { ...requestOptions });
}
